import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import blogStyles from './BlogStyles';
import Hero from "./components/Hero";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import CTA from "../../components/CTA/CTA";

export default function Blog() {
  return (
    <Fragment>
      <Navbar fixedScrolled/>
      <Hero />
      <CTA 
        title="Servicio profesional de renta de cajas secas en Hidalgo" 
        description="Grupo GM ofrece renta de cajas secas en Hidalgo, con equipos en excelente estado y atención profesional. Brindamos soluciones confiables y rápidas para transporte y logística. Si buscas servicio seguro y eficiente, Grupo GM es tu mejor opción."
        buttonText="Solicitar cotización"
      />
      <Footer />
    </Fragment>
  )
}
